import isString from 'lodash/isString';
import type { ReactNode } from 'react';

import type { BaseComponentProps } from '../../utils/types';
import { IconButton, type IconButtonProps } from './IconButton';

export interface ClipboardButtonProps
  extends BaseComponentProps,
    Omit<IconButtonProps, 'onClick' | 'children' | 'tooltip'> {
  toCopy: string;
  children?: ReactNode;
}

export const ClipboardButton = ({
  toCopy,
  children,
  ...buttonProps
}: ClipboardButtonProps) => (
  <>
    <IconButton
      disabled={!isString(toCopy)}
      tooltip="Copy"
      icon="content_copy"
      onClick={() => textToClipboard(toCopy)}
      {...buttonProps}
    />
  </>
);

export const textToClipboard = (text: string) => {
  if (!navigator.clipboard) {
    const input = document.createElement('input');
    input.value = text;
    document.body.appendChild(input);
    input.select();
    input.setSelectionRange(0, 99999);
    document.execCommand('copy');
    document.body.removeChild(input);
  } else {
    navigator.clipboard.writeText(text);
  }
};
